import React from 'react'
import PropTypes from 'prop-types'

const SmsIcon = (props) => {
  const {
    color = '#183560',
    classes = 'w-20',
    revert = false,
    notBackground = false,
    backgroundColor = '#ffffff',
  } = props
  const colorIcon = revert ? '#ffffff' : color
  const background = notBackground ? 'none' : revert ? color : backgroundColor
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classes}
    >
      <path
        d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10Z"
        fill={background}
      />
      <path
        d="M8.3 9.95C8.45583 9.95 8.58655 9.8972 8.69215 9.7916C8.79775 9.686 8.85037 9.55547 8.85 9.4C8.85 9.24417 8.7972 9.11363 8.6916 9.0084C8.586 8.90317 8.45547 8.85037 8.3 8.85C8.14417 8.85 8.01363 8.9028 7.9084 9.0084C7.80317 9.114 7.75037 9.24453 7.75 9.4C7.75 9.55583 7.8028 9.68655 7.9084 9.79215C8.014 9.89775 8.14453 9.95037 8.3 9.95ZM10.5 9.95C10.6558 9.95 10.7866 9.8972 10.8921 9.7916C10.9978 9.686 11.0504 9.55547 11.05 9.4C11.05 9.24417 10.9972 9.11363 10.8916 9.0084C10.786 8.90317 10.6555 8.85037 10.5 8.85C10.3442 8.85 10.2136 8.9028 10.1084 9.0084C10.0032 9.114 9.95037 9.24453 9.95 9.4C9.95 9.55583 10.0028 9.68655 10.1084 9.79215C10.214 9.89775 10.3445 9.95037 10.5 9.95ZM12.7 9.95C12.8558 9.95 12.9865 9.8972 13.0921 9.7916C13.1977 9.686 13.2504 9.55547 13.25 9.4C13.25 9.24417 13.1972 9.11363 13.0916 9.0084C12.986 8.90317 12.8555 8.85037 12.7 8.85C12.5442 8.85 12.4136 8.9028 12.3084 9.0084C12.2032 9.114 12.1504 9.24453 12.15 9.4C12.15 9.55583 12.2028 9.68655 12.3084 9.79215C12.414 9.89775 12.5445 9.95037 12.7 9.95ZM5 16V6.1C5 5.7975 5.1078 5.53863 5.3234 5.3234C5.539 5.10817 5.79787 5.00037 6.1 5H14.9C15.2025 5 15.4615 5.1078 15.6771 5.3234C15.8927 5.539 16.0004 5.79787 16 6.1V12.7C16 13.0025 15.8924 13.2615 15.6771 13.4771C15.4619 13.6927 15.2029 13.8004 14.9 13.8H7.2L5 16Z"
        fill={colorIcon}
      />
    </svg>
  )
}

SmsIcon.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.string,
  revert: PropTypes.bool,
  notBackground: PropTypes.bool,
  backgroundColor: PropTypes.string,
}

export default React.memo(SmsIcon)
